<!--
  KS two-letter icon — clean standard sans-serif style.
  Uses SVG <text> for crisp letterforms at any size.
  100% currentColor — works with <el-icon color="…"> and theme switching.

  Usage:
    <el-icon :size="24"><IconLetterS /></el-icon>
    <el-icon :size="32" color="#409eff"><IconLetterS /></el-icon>
-->
<template>
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <text
      x="12"
      y="17"
      text-anchor="middle"
      font-family="Arial, Helvetica, sans-serif"
      font-size="13"
      font-weight="600"
      letter-spacing="0.5"
      fill="currentColor"
    >KS</text>
  </svg>
</template>


